export default {
  certifications: [],
  certificationLoadingStatus: 'not loading'
}
